






































































import { OverdraftItem, OverdraftItemImpl } from "@/store/finance/types";
import { Component, Ref, Vue } from "vue-property-decorator";
import { NewPriceWings, SelectWings } from "wings-ui-components";
import { notifyError } from "@/utils/notify-helper";
import { Action, Getter } from "vuex-class";
import { PartnerItem } from "@/store/settings/partners/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import axios from "axios";

@Component({ components: { NewPriceWings, SelectWings } })
export default class OverdraftSettings extends Vue {
  @Ref("validator") validator: any;

  @Action("putOverdraft") actionSave: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("actionLog") actionLog: any;

  private partnerId: number | null = null;
  private item: OverdraftItem = new OverdraftItemImpl();
  partnersList: PartnerItem[] = [];
  private logObject: ActionLog = {};

  back(): void {
    this.$router.push("/finances/overdrafts");
  }

  async getPartnersList(filter: any) {
    const partners = await this.actionGetPartners(filter);
    this.partnersList = partners.filter((e:any) => e.prepaid === true);
  }

  async onTopUp(): Promise<void> {
    let valid: boolean = await this.validator.validate();
    if (valid) {
      try {
        let object = {
          id: this.partnerId,
          item: this.item,
        };
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Editing",
          action_status: "success",
          object_type: "Threshold",
          addititional_info: getTranslatedParams(this.item)
        };
        await this.actionSave(object);
        await this.actionLog(this.logObject);
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors);
      }, 100);
    }
  }
}
